module.exports = __webpack_public_path__ + "img/Home_Desktop_03.f5e2c6e7.jpg";